import { graphql } from "relay-runtime"

export const deDuplicatePatientChangedSubscription = graphql`
  subscription useDeDuplicatePatientChangedSubscription {
    de_patientChanged {
      id
      firstName
      lastName
      gender
      displayId
      contactChannel
      country
    }
  }
`
